import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

// A simple wrapper over react-router's <Redirect /> that
// makes sure SEO4Ajax is notified of the redirect. SEO4Ajax
// can then start serving the appropriate status codes to search
// engines.

export default class SEOFriendlyRedirect extends Component {
  static propTypes = {
    statusCode: PropTypes.oneOf([301, 302]),
  };

  static defaultProps = {
    statusCode: 301,
  };

  componentDidMount() {
    // SEO4Ajax sets onCaptureReady on window - when SEO4Ajax is rendering this error page, we can execute it
    // with a status code so that we can override the standard 200 with a more appropriate status code for it to cache
    // (or not cache, if a 5xx) and later return to bots
    if (window.onCaptureReady) {
      window.onCaptureReady(this.props.statusCode);
    }
  }

  render() {
    return <Redirect {...this.props} />;
  }
}
